// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_xlsx_dist_xlsx_mini_min_js":"6048a140c065d7c7","node_modules_xlsx_xlsx_mjs":"865f120ffaf006ec"}[chunkId] + ".js";
};